module.exports = __webpack_public_path__ + "static/media/30.6373a508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/30.jpg
// module id = 976
// module chunks = 0